// Nơi các module giữ trạng thái cấp module (ngoài React Query) đăng ký hàm dọn, để AuthProvider
// xoá sạch dữ liệu của người cũ khi đăng xuất / đổi người mà không phải biết từng module.
const resets = new Set<() => void>();

export function onSessionReset(fn: () => void): () => void {
  resets.add(fn);
  return () => { resets.delete(fn); };
}

export function runSessionReset(): void {
  resets.forEach((fn) => fn());
}
